<template>
    <!-- RD-163: загрузка/ошибка блока внутри карточки; незагруженный блок не редактируется. -->
    <div v-if="status === 'idle' || status === 'loading'" class="ds-settings-skeleton" aria-busy="true" aria-label="Загрузка">
        <div v-for="index in rows" :key="index" class="ds-settings-skeleton-row"></div>
    </div>
    <div v-else-if="status === 'error'" class="ds-settings-block-error" role="alert">
        <span>{{ errorText }}</span>
        <button type="button" class="ds-glass-btn ds-glass-btn-secondary" @click="emit('retry')">Повторить</button>
    </div>
    <slot v-else />
</template>

<script setup lang="ts">
import type { LoadStatus } from './useSettingsEditor'

withDefaults(defineProps<{
    status: LoadStatus
    errorText: string
    rows?: number
}>(), {
    rows: 3,
})

const emit = defineEmits<{
    (event: 'retry'): void
}>()
</script>
